import { render, staticRenderFns } from "./CompanyDocumentsTable.vue?vue&type=template&id=297d36be&"
import script from "./CompanyDocumentsTable.vue?vue&type=script&lang=js&"
export * from "./CompanyDocumentsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports